import store from "../../store";

const Bot = () => import("./Bot");
const Logs = () => import("./Logs");
const ifAuthenticated = (to, from, next) => {
    if (store.getters.isLoggedIn) {
        next();
        return;
    }
    next("/login");
};

export default [
    {
        path: "/console/console/",
        name: "console",
        meta: { menu: "console", title: "Console" },
        component: Bot,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/console/logs/",
        name: "logs",
        meta: { menu: "console", title: "Logs" },
        component: Logs,
        beforeEnter: ifAuthenticated,
    },
];
